import { RefObject, useEffect } from 'react'

import { datadogLogs } from '@datadog/browser-logs'
import { canUseWindow } from '@library/environment'

export function useAutoplayOnIntersect(
  videoRef: RefObject<HTMLVideoElement>,
  userPausedRef: RefObject<boolean>,
) {
  useEffect(() => {
    if (!canUseWindow) return undefined
    const video = videoRef.current
    if (!video) return undefined

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Respect an explicit pause: don't resume autoplay when a video the user paused
            // scrolls back into view. Scrolling away leaves userPausedRef untouched, so only a
            // button click counts as intent.
            if (userPausedRef.current) return
            video
              .play()
              .catch((error) => datadogLogs.logger.error('Recipe video play failed', error))
          } else {
            video.pause()
          }
        })
      },
      { threshold: 0.5 },
    )

    observer.observe(video)
    return () => observer.disconnect()
  }, [videoRef, userPausedRef])
}
